import React, {PropTypes as T} from 'react';

const ModalCautionIcon = ({ width = 24, height = 24, color, className = '' }) => (
  <svg
    aria-label="Modal Caution Icon"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__modalcaution ${className}`}
  >
    <path style={{fillRule: 'evenodd'}}
      d="M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11zm0-2a9 9 0 1 0 0-18
      9 9 0 0 0 0 18zm-1.1-5.7h2.2v2.2H9.9v-2.2zm-.55-8.8h3.3l-.55 7.15H9.9L9.35 5.5z" />
  </svg>
);

ModalCautionIcon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  ModalCautionIcon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_modal_caution.js